import React from 'react'
import { Link } from 'react-router-dom'
import { FaCashRegister, FaFileMedical } from 'react-icons/fa'
function Dashboard () {
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className='content-wrapper'>
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active'>
                      Trail Balance List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className='content'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    <div className='card-header'>
                      <h1 className='card-title font-weight-bold px-3 py-3'>
                        Trail Balnace as at End of the 2022
                      </h1>

                      <div className='card-body'>
                        <table id='example1' className='table'>
                          <thead className='text-center ok'>
                            <tr>
                              <th>No</th>
                              <th>Account Name</th>
                              <th>Debit(MMK)</th>
                              <th>Credit(MMK)</th>
                            </tr>
                          </thead>

                          <tbody className='text-center'>
                            <tr>
                              <td></td>
                              <td>
                                <u>Revenue</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            {/* <?php $i=1;
                $tot_amt = 0;
            ?>
            @foreach ($account as $acc) */}
                            <tr>
                              <td>1</td>
                              <td>Revenue</td>
                              <td></td>
                              <td>11964</td>
                            </tr>
                            {/* @endforeach */}
                            <tr>
                              <td></td>
                              <td>
                                <u>Other Income</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Income from Other</td>
                              <td></td>
                              <td></td>
                            </tr>
                            {/* <?php $m=1;
                $tot_amt3 = 0;
            ?>
            @foreach ($account3 as $acc) */}
                            <tr>
                              <td>1</td>
                              <td>Staff Loan</td>
                              <td></td>
                              <td>0</td>
                            </tr>
                            {/* @endforeach */}
                            <tr>
                              <td></td>
                              <td>Bank Interest Income</td>
                              <td></td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>(-)Direct Expense 20-21 (Kakahtoke)</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            {/* <?php $k=1;
            ?>
            @foreach ($account4 as $acc) */}
                            <tr>
                              <td>1</td>
                              <td>test name one</td>
                              <td>250000 </td>
                              <td></td>
                            </tr>
                            {/* @endforeach */}
                            <tr>
                              <td></td>
                              <td>
                                <u>(-)Operation Other Expense</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Predemand</td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>(-)Operation Indirect Expense</u>
                              </td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>(-)Operation Other Expense</u>
                              </td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>(-)Direct Expense 20-21 (MOHA)</u>
                              </td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>(-)Office Expense</u>
                              </td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Retained Earning</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Retained Earning up to 30.9.2019</td>
                              <td></td>
                              <td>0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Retained Earning up to 30.9.2020</td>
                              <td></td>
                              <td>0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Write Off Tender</td>
                              <td></td>
                              <td>0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Ajustment</td>
                              <td></td>
                              <td>0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Capital</u>
                              </td>
                              <td></td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Cash & Bank Balance</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Cash in Hand</td>
                              <td>10964141</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Bank Balance</td>
                              <td>-13582295</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Prepaid Expense(Advance Payment)</td>
                              <td>-</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Fixed Assets</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Fixed Assets</td>
                              <td></td>
                              <td></td>
                            </tr>
                            {/* <?php $i=1;
                $tot_amt = 0;
               ?> */}
                            {/* {{-- @foreach ($account as $acc)
            <tr>
                <td>{{$i++}}</td>
                <td>{{$acc->account_name}}</td>
                <td>{{$acc->amount}}</td>
                <td></td>
            </tr>
            @endforeach --}} */}
                            <tr>
                              <td></td>
                              <td>Accumulated Depriciation on Fixed Assets</td>
                              <td></td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Intangible Assets</td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Receiable</u>
                              </td>
                              <td></td>
                              <td>0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Payable</u>
                              </td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Other Payable</u>
                              </td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Loan A/C</u>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Loan</td>
                              <td></td>
                              <td>0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <u>Personal Loan A/C</u>
                              </td>
                              <td>0</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td>-</td>
                              <td>-</td>
                            </tr>
                          </tbody>
                        </table>
                        {/* <?php

            session_start();

            echo '<br /><a href="balancesheet_acc_list" className="float-left">Balance Sheet</a>';

              ?> */}
                        <a href='/balance_sheet' className='float-left'>
                          Balance Sheet
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>{' '}
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>

      <script src="{{asset('plugins/jquery/jquery.min.js')}}"></script>
      <script src="{{asset('plugins/jquery-ui/jquery-ui.min.js')}}"></script>

      {/* <!-- Resolve conflict in jQuery UI tooltip with Bootstrap tooltip -->*/}
      <script>$.widget.bridge('uibutton', $.ui.button)</script>
      <script src="{{asset('plugins/bootstrap/js/bootstrap.bundle.min.js')}}"></script>
      <script src="{{asset('plugins/chart.js/Chart.min.js')}}"></script>
      <script src="{{asset('plugins/sparklines/sparkline.js')}}"></script>
      <script src="{{asset('plugins/jquery-knob/jquery.knob.min.js')}}"></script>
      <script src="{{asset('plugins/moment/moment.min.js')}}"></script>
      <script src="{{asset('plugins/daterangepicker/daterangepicker.js')}}"></script>

      <script src="{{asset('plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js')}}"></script>
      <script src="{{asset('plugins/summernote/summernote-bs4.min.js')}}"></script>
      <script src="{{asset('plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js')}}"></script>
      <script src="{{asset('dist/js/adminlte.js')}}"></script>

      <script src="{{asset('dist/js/demo.js')}}"></script>

      <script src="{{asset('plugins/datatables/jquery.dataTables.js')}}"></script>
      <script src="{{asset('plugins/datatables/dataTables.bootstrap')}}"></script>
      <script src="{{asset('plugins/datatables-bs4/js/dataTables.bootstrap4.js')}}"></script>
      <script src="{{asset('plugins/bootstrap-material-datetimepicker/js/bootstrap-material-datetimepicker.js')}}"></script>
    </>
  )
}
export default Dashboard
